export enum EducationTypeEnum {
    OFFICIAL = 'official',
    FREE = 'free',
}
